/**
 * Route for `auto-alert-affiliate-via-email-in-app`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutoAlertAffiliateViaEmailInAppPage } from "../features/auto-alert-affiliate-via-email-in-app/AutoAlertAffiliateViaEmailInAppPage";

export const autoAlertAffiliateViaEmailInAppRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/auto-alert-affiliate-via-email-in-app",
	component: AutoAlertAffiliateViaEmailInAppPage,
});

export default autoAlertAffiliateViaEmailInAppRoute;
